var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg002Coverall = function Svg002Coverall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151 120h30v302h60V300h30v122h60V120h30v60h60v-75c0-39.421-30.681-71.488-69.36-74.429L256 126.211l-95.64-95.64C121.681 33.512 91 65.579 91 105v75h60zm90 30h30v30h-30zm0 60h30v30h-30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316 23.789 292.211 0h-72.422L196 23.789l60 60zM181 452h60v60h-60zM91 210h60v60H91zM361 210h60v60h-60zM271 452h60v60h-60z"
  })));
};
export default Svg002Coverall;